import { FormEvent, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { getApiErrorMessage, portalApi } from '../../api/client';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { TotpInput } from '../../components/ui/TotpInput';

export function SecurityPage() {
  const [secret, setSecret] = useState('');
  const [otpauth, setOtpauth] = useState('');
  const [code, setCode] = useState('');
  const [enabled, setEnabled] = useState(false);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  const setup = async () => {
    setErr('');
    try {
      const r = await portalApi.setup2fa();
      setSecret(r.secret);
      setOtpauth(r.otpauth_url);
    } catch (ex) {
      setErr(getApiErrorMessage(ex));
    }
  };

  const enable = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await portalApi.enable2fa(code);
      setEnabled(true);
      setMsg('2FA enabled successfully');
    } catch (ex) {
      setErr(getApiErrorMessage(ex));
    }
  };

  return (
    <div className="max-w-lg space-y-6">
      <h2 className="font-display text-2xl">Security & 2FA</h2>
      <p className="text-sm text-onyx-muted">
        Google Authenticator is required for login (when enabled), password changes, and payout submissions.
      </p>
      {err ? <p className="text-sm text-onyx-danger">{err}</p> : null}
      {msg ? <p className="text-sm text-onyx-success">{msg}</p> : null}
      <Card title="Google Authenticator">
        {!secret ? (
          <Button onClick={setup}>Generate QR code</Button>
        ) : (
          <div className="space-y-4">
            {otpauth ? (
              <div className="flex justify-center p-4 bg-white rounded-xl">
                <QRCodeSVG value={otpauth} size={180} />
              </div>
            ) : null}
            <p className="text-xs font-mono break-all text-onyx-muted">Manual key: {secret}</p>
            <form onSubmit={enable} className="space-y-4">
              <TotpInput value={code} onChange={setCode} />
              <Button type="submit" disabled={code.length !== 6 || enabled}>
                Enable 2FA
              </Button>
            </form>
          </div>
        )}
      </Card>
    </div>
  );
}
